import React from "react";
import {
    ItemQuantityModel,
    QuantityField,
} from "../models/item_quantity_model";

export default class QtyInput extends React.Component<{
    label: string;
    field: QuantityField;
    model: ItemQuantityModel;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}> {
    render(): React.ReactNode {
        const { label, field, model, onChange } = this.props;

        return (
            <>
                <label className="block text-sm text-gray-600">{label}</label>

                <input
                    type="text"
                    inputMode="numeric"
                    pattern="[0-9]*"
                    value={model[field]}
                    placeholder="Big Qty"
                    className="w-full border rounded-lg px-3 py-2 mt-1"
                    onChange={(e) => {
                        const value = e.target.value;
                        if (/^\d*$/.test(value)) {
                            onChange(e);
                        }
                    }}
                    onKeyDown={(e) => {
                        const allowedKeys = [
                            "Backspace",
                            "ArrowLeft",
                            "ArrowRight",
                            "Tab",
                        ];
                        if (
                            !/^\d$/.test(e.key) &&
                            !allowedKeys.includes(e.key)
                        ) {
                            e.preventDefault();
                        }
                    }}
                />
            </>
        );
    }
}
